import * as React from "react";
import PropTypes from 'prop-types';

const SvgTimer = props => {
  if (props.id !== "_svgtimer") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 36 36" {...props}><g fill="none" fillRule="evenodd"><circle cx={18} cy={18} r={16} stroke="#111" strokeWidth={4} /><rect width={3.6} height={12.6} x={15.3} y={9.9} fill="#C00" rx={1.8} /><rect width={3.6} height={10.288} x={18.188} y={13.876} fill="#C00" rx={1.8} transform="rotate(60 19.988 19.02)" /></g></svg>;
};

SvgTimer.displayName = "_svgtimer";
SvgTimer.propTypes = {
  id: PropTypes.string
};
SvgTimer.defaultProps = {
  id: ''
};
export default SvgTimer;